import z from 'zod';

export enum TodoRepeatUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  DAY_OF_WEEK = 'dayOfWeek',
}

export const todoRepeatUnitSchema = z.enum(TodoRepeatUnit);
